module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-chevy.1e70ed91.png";